/* eslint-disable react/prop-types */
/* for some reason, prop-types validation is broken on this file */
import GatsbyImage from "gatsby-image";
import PropTypes from "prop-types";
import React from "react";

// prefer a direct import for shadowing
import { Image } from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero/image";
import { Sizing } from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero/sizing";

const ImageComponentPragma = props => {
  const { alt, className, file, src } = props;
  if (file) {
    return (
      <Sizing>
        <GatsbyImage
          alt={alt}
          className={className}
          fluid={file.childImageSharp.fluid}
          imgStyle={{ objectPosition: undefined }}
          loading="eager" // for some reason Webkit doesn't support lazy
          placeholderClassName={className}
        />
      </Sizing>
    );
  }
  return <Image alt={alt} className={className} src={src} />;
};

ImageComponentPragma.displayName = "Image";

ImageComponentPragma.propTpes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  file: PropTypes.shape({
    childImageSharp: PropTypes.shape({ fluid: PropTypes.object }),
  }),
  src: PropTypes.string,
};

export { ImageComponentPragma as Image };
